import * as React from 'react';
import I18nContext from 'src/contexts/i18n-context';

/**
 * @deprecated Use `useLabelTranslation` from `src/hooks/useLabelTranslation` instead.
 */
export default function useI18n() {
  return React.useContext(I18nContext);
}
